import { render, staticRenderFns } from "./opportunities.page.vue?vue&type=template&id=180d724c&scoped=true&"
import script from "./opportunities.page.vue?vue&type=script&lang=js&"
export * from "./opportunities.page.vue?vue&type=script&lang=js&"
import style0 from "./opportunities.page.vue?vue&type=style&index=0&id=180d724c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180d724c",
  null
  
)

export default component.exports